import { GuestAuth } from 'domain/usecases/auth/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteGuestAuth implements GuestAuth {
  private readonly url: string;

  private readonly httpClient: HttpClient<GuestAuth.Model>;

  constructor(url: string, httClient: HttpClient<GuestAuth.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  guest = async (params: GuestAuth.Params): Promise<GuestAuth.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
